export const SaleEndDate = new Date('2026-01-02T12:00:00Z');
